import React from 'react';
import SelectField from 'components/input/SelectField/SelectField';

const EnabledFilter = <SelectField
    label='filters.components.enabled.label'
    source='is_enabled'
    fullWidth={ true }
    floatingLabelFixed={ true }
    choices={ [
        {
            id: '1',
            name: 'filters.components.enabled.choices.active',
        },
        {
            id: '0',
            name: 'filters.components.enabled.choices.inactive',
        },
    ] }
/>;

export default EnabledFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/EnabledFilter.js